"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _consts = require("./consts");
var apiActions = _interopRequireWildcard(require("./actions"));
var _simpleDataReducer = require("../../../../common/utils/simpleDataReducer");
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function (e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && Object.prototype.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
const completeProfileReducer = (0, _simpleDataReducer.createReducer)(apiActions.COMPLETE_PROFILE_API);
const guestCheckoutRegisterReducer = (0, _simpleDataReducer.createReducer)(apiActions.GUEST_CHECKOUT_REGISTER_API);
const patientProfileReducer = (0, _simpleDataReducer.createReducer)(apiActions.GET_PATIENT_PROFILE_API);
const patientProfileListReducer = (0, _simpleDataReducer.createReducer)(apiActions.GET_PATIENT_PROFILE_LIST_API);
const deletePatientProfile = (0, _simpleDataReducer.createReducer)(apiActions.DELETE_PROFILE_API);
const checkPatientInHis = (0, _simpleDataReducer.createReducer)(apiActions.CHECK_PATIENT_IN_HIS_API);
const checkPatientInAkhilHis = (0, _simpleDataReducer.createReducer)(apiActions.CHECK_PATIENT_IN_AKHILHIS_API);
const familyMember = (0, _simpleDataReducer.createReducer)(apiActions.FAMILY_MEMBER_API);
const addFamilyMember = (0, _simpleDataReducer.createReducer)(apiActions.ADD_FAMILY_MEMBER_API);
const referralEligibility = (0, _simpleDataReducer.createReducer)(apiActions.SET_REFERRAL_ELIGIBILITY_API);
var _default = exports.default = {
  [_consts.COMPLETE_PROFILE]: completeProfileReducer,
  [_consts.GUEST_CHECKOUT_REGISTER]: guestCheckoutRegisterReducer,
  [_consts.PATIENT_PROFILE]: patientProfileReducer,
  [_consts.PATIENT_PROFILE_LIST]: patientProfileListReducer,
  [_consts.DELETE_PATIENT_PROFILE]: deletePatientProfile,
  [_consts.CHECK_PATIENT_IN_HIS]: checkPatientInHis,
  [_consts.CHECK_PATIENT_IN_AKHILHIS]: checkPatientInAkhilHis,
  [_consts.FAMILY_MEMBER]: familyMember,
  [_consts.ADD_FAMILY_MEMBER]: addFamilyMember,
  [_consts.REFERRAL_ELIGIBILITY]: referralEligibility
};